export const MAIN_PROVIDER_METHOD_NAME = "T42.Search.Provider";

export const MAIN_CLIENT_METHOD_NAME = "T42.Search.Client";

export const SEQUELIZER_INTERVAL_MS = 10;

export const FLUSH_SEQUELIZER_INTERVAL_MS = 10;

export const FLUSH_TIMEOUT_MS = 100;

export const STALE_QUERY_TIMEOUT_MS = 900000;